/**
 * feat-354-auto-copy-lessons — every on-screen string for the Admin-only
 * "Auto-copy a lesson every weekday" tenant toggle (design/NOTES.md §3, A1–A6),
 * in ONE place. Same shape as `assistant/assistantToggleCopy.ts`. Edit the wording
 * here, never at the call site.
 */

/** A1 — switch label. */
export const AUTO_COPY_TOGGLE_LABEL = 'Auto-copy a lesson every weekday';
/** A2 — InfoPopover trigger label. */
export const AUTO_COPY_TOGGLE_HELP_LABEL = 'What does Auto-copy do?';
/** A3 — InfoPopover lead-in, rendered bold. */
export const AUTO_COPY_TOGGLE_HELP_LEAD = 'Auto-copy.';
/** A4 — InfoPopover body (typographic apostrophes). */
export const AUTO_COPY_TOGGLE_HELP_BODY =
  'At 5 AM Pacific, Monday to Friday, Bespoke copies one lesson from this client’s curriculum, in track order, under a new title. The copy goes live right away, through drip release if drip is on. Editing an original doesn’t change copies already made.';
/** A5 — in-flight indicator. */
export const AUTO_COPY_TOGGLE_SAVING = 'Saving…';
/** A6 — inline error. */
export const autoCopyToggleSaveFailed = (message?: string | null) =>
  message ? `Failed to update auto-copy: ${message}` : 'Failed to update auto-copy';
